import { Tag, TagColor } from '@/components/tag/Tag'
import { CaseStatusEnum, WarningCaseStatus } from '@/citator/schema/case-status-schema'
import { kCaseStatusDefinitions } from '@/citator/utils/case-status-definitions'

type CaseStatusTagProps = {
  status: WarningCaseStatus
  textCase?: 'all-caps' | 'lowercase'
}

const tagColors: Record<WarningCaseStatus, Extract<TagColor, 'Red' | 'Yellow' | 'Orange'>> = {
  [CaseStatusEnum.likely_bad]: 'Red',
  [CaseStatusEnum.overruling_risk]: 'Orange',
  [CaseStatusEnum.caution]: 'Yellow',
}

export function CaseStatusTag({ status, textCase = 'all-caps' }: CaseStatusTagProps) {
  const color = tagColors[status]
  const { label } = kCaseStatusDefinitions[status]
  const isLowercase = textCase === 'lowercase'
  return (
    <Tag variant="tonal" color={color} size="xs" textCase={isLowercase ? 'normal' : 'all-caps'}>
      {isLowercase ? label.toLowerCase() : label}
    </Tag>
  )
}
